import { render } from "./KnowledgeCourseRecommendations.vue?vue&type=template&id=b20c27a6&scoped=true"
import script from "./KnowledgeCourseRecommendations.vue?vue&type=script&lang=js"
export * from "./KnowledgeCourseRecommendations.vue?vue&type=script&lang=js"

import "./KnowledgeCourseRecommendations.vue?vue&type=style&index=0&id=b20c27a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b20c27a6"]])

export default __exports__